export enum RequestDetailTab {
  REPORTS = 'reports',
  REFERENCES = 'references',
  ANNEXES = 'annexes',
  NOTIFICATIONS = 'notifications',
  NOTES = 'comments',
  REQUEST_CHANGES_HISTORY = 'requestChangesHistory'
}
